<script lang="ts">
export default {
  name: 'PromptEntityContextPanel',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import Toggle from '@/components/v2/Toggle.vue';

// The three entity-context flags gate which reference-data lookups the agentic
// engine performs per entity. They persist on the output schema row, so they
// need a schema to live on.
const carrier = defineModel<boolean>('carrier', { default: false });
const coverageType = defineModel<boolean>('coverageType', { default: false });
const wholesaler = defineModel<boolean>('wholesaler', { default: false });

const props = defineProps<{
  readonly?: boolean;
  schemaPresent?: boolean;
}>();

const disabled = computed(() => props.readonly || !props.schemaPresent);
</script>

<template>
  <div class="mb-4 rounded-md border border-slate-200 bg-slate-50 px-4 py-3">
    <div class="flex items-center gap-2">
      <h4 class="text-sm font-medium text-slate-700">Entity Lookup</h4>
      <span
        v-if="!schemaPresent"
        class="text-xs text-slate-500 italic"
        >Define an output schema first</span
      >
      <span
        v-else-if="readonly"
        class="text-xs text-slate-500 italic"
        >Editing is only allowed for draft prompts</span
      >
    </div>
    <p class="mt-1 text-xs text-slate-500">Enable reference-data lookup for entities extracted by this prompt.</p>
    <div class="mt-2 flex flex-wrap items-center gap-x-8 gap-y-1">
      <Toggle
        id="entity-context-carrier"
        v-model="carrier"
        Context
        label="Carrier"
        size="sm"
        :disabled="disabled" />
      <Toggle
        id="entity-context-coverage-type"
        v-model="coverageType"
        label="Coverage type"
        size="sm"
        :disabled="disabled" />
      <Toggle
        id="entity-context-wholesaler"
        v-model="wholesaler"
        label="Wholesaler"
        size="sm"
        :disabled="disabled" />
    </div>
  </div>
</template>
